import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppConfig } from '../models/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  static config: IAppConfig;
  private http: HttpClient;
  private readonly url = `assets/config/config.json`;

  constructor(handler: HttpBackend) {
    // Do not use any interceptor
    this.http = new HttpClient(handler);
  }

  init(): Promise<any> {
    return this.http.get(this.url).toPromise().then(value => {
      AppConfigService.config = value as IAppConfig;
    });
  }

  getConfig(): IAppConfig {
    return AppConfigService.config;
  }
}
